export enum TypicalEquipmentLabelEnum {
  BRK = 'breaker',
  FD = 'firedamper',
  FE = 'final element - generic',
  FWP = 'fire water pump',
  MOT = 'motor',
  NFS = 'non-feedback signal',
  VLV = 'valve',
  VLV_P = 'valve with partial stroke',
}
